import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-stone-800/60 bg-[#0B0B0D]">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div>
            <p className="font-display text-2xl text-[#F5F3EF]">
              Valeur <span className="italic text-[#D4AF37]">Prestige</span>
            </p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-stone-500">
              Estimation immobilière de prestige · Paris & Île-de-France
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/vendre" data-testid="footer-cta-vendre" className="btn-ghost !text-xs">
              Vendre
            </Link>
            <Link to="/estimation" data-testid="footer-cta-estimation" className="btn-ghost !text-xs">
              Estimation gratuite
            </Link>
          </div>
        </div>
        <div className="mt-10 flex flex-col justify-between gap-4 border-t border-stone-800/60 pt-6 text-xs text-stone-600 lg:flex-row">
          <p>© {new Date().getFullYear()} Valeur Prestige — Estimation indicative, document non contractuel.</p>
          <div className="flex gap-6">
            <Link to="/confidentialite" data-testid="footer-privacy-link" className="transition-colors hover:text-stone-400">
              Mentions légales & confidentialité
            </Link>
            <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-stone-400">
              Espace conseiller
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
